__webpack_require__.p = "https://demo.mobiworkx.com/_next/";